<div class="content container-fluid"
  [ngStyle]="{'background-image': 'url(' + BackgroundImageUrl + ')','box-shadow':' 0px 0px 14px 8px #bcbcbc'}">
<!-- <div class="frameImg" style="background-image: url('/assets/images/new_animation_large.gif');"> -->
    <div class="circleParent" [ngStyle]="{'background-image': 'url('+ plateUrl +')'}">
        <ul class="circle" id="spin" [ngClass]="animationNumber" ngDefaultControl>
            <li *ngFor="let c of roulette.Coupons">
                <div class="text">
                    <div class="couponIcon" style="width: 10%; height: 10%; display: block; margin:auto;"
                        [ngStyle]="{'-webkit-mask-box-image': 'url('+c.IconUrl+')'}">
                    </div>
                    <span class="couponText">
                        {{c.Text}}<br>
                    </span>
                </div>
            </li>
        </ul>
        <div (click)="win()" id="rollRnd2" [ngStyle]="{'background-image': 'url(' + ButtonUrl + ')'}"></div>
    </div>
<!-- </div> -->
<audio autoplay>
    <source *ngIf="firstSound==true" src="/assets/roulette_cutted.mp3" type="audio/mp3">
</audio>
<audio autoplay>
    <source *ngIf="winSound==true" src="/assets/win_2.mp3" type="audio/mp3">
</audio>
</div>
<!-- <app-confety *ngIf="showConfety==true"></app-confety> -->
<!-- <span *ngIf="commentGame" class="comment">{{commentGame}}</span> -->